import { render, staticRenderFns } from "./DialogPdr.vue?vue&type=template&id=371fb0b0&"
import script from "./DialogPdr.vue?vue&type=script&lang=js&"
export * from "./DialogPdr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports